<template>
<div class='order-dialog'>
  <el-dialog :title="$t('actions.project.settings.logo.title')" size="small" :visible.sync="dialogVisible">
    <p style='color:#333;'>{{$t('hint.project.logo.main')}}</p>

    <el-form v-if="logosLeft === 0">
      <el-form-item :label="$t('common.order.labels.price')">
        ￥ 99 / {{$t('common.project')}}
        <a class='price-link' href='/price?closeOnPQuota=true' target='_blank'><i class='ppj-icon-gift'></i>升级账户，100个项目去 logo 只需￥1999！</a>
      </el-form-item>
      <el-form-item :label="$t('common.order.labels.payType')">
        <el-radio-group theme='info' class='payment' v-model='payType'>
          <el-radio-button label='wechat'>{{$t('common.order.wechat')}}</el-radio-button>
          <el-radio-button label='alipay'>{{$t('common.order.alipay')}}</el-radio-button>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div class='has-quotas' v-else>
      <el-checkbox theme="info" :checked="true" :disabled="true">
        使用账号修改Logo额度（{{logosLeft === null ? '不限次数' : `还剩${logosLeft}次`}}）
      </el-checkbox>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type='text' @click="close()">{{$t('common.buttons.cancel')}}</el-button>
      <el-button type="primary" @click="placeOrder()">{{$t('common.buttons.submit')}}</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
      payType: 'wechat',
      name: null,
      id: null,
      dialogVisible: false
    }
  },
  computed: {
    logosLeft() {
      return this.$store.state.quota.summary.logos_left
    }
  },
  methods: {
    placeOrder() {
      let vm = this

      let success = () => {
        vm.$store.dispatch('project/get', {
          id: vm.id,
          force: true
        }).then(_ => {
          vm.close()
        })
        vm.$message('该项目已可以修改 logo')
      }

      if (vm.logosLeft !== 0) {
        vm.$store.dispatch('quota/consume', {
          key: 'logo',
          project_id: vm.id
        }).then(success)
      } else {
        vm.$order({
          package: 'one_time_logo',
          project_id: vm.id,
          payment_method: vm.payType,
          success: success
        })
      }
    },
    open(params) {
      let vm = this
      vm.$store.dispatch('refresh').then(_ => {
        vm.name = params.name
        vm.id = params.id
        vm.dialogVisible = true
      })
    },
    close() {
      this.name = null
      this.id = null
      this.dialogVisible = false
    }
  }
}
</script>

<style lang='scss' scoped>
.order-dialog {
    .payment {
        vertical-align: text-top;
    }

    .price-link {
        float: right;
        color: $color-primary;
        .ppj-icon-gift {
            margin-right: 0.4em;
        }
        &:focus,
        &:hover {
            color: lighten($color-primary, 10%);
        }
    }
}
</style>



// WEBPACK FOOTER //
// order.dialog.vue?5369661d